import React, { PropTypes } from 'react';
import ProjectLink from 'common/containers/project_link';
import Money from 'common/components/money';
import { getTimeLeftLabel } from 'common/utils';
import Feedback from 'common/containers/project_feedback';
import { v4 } from 'node-uuid';

const ActiveProjects = ({ is_client, activeProjects }) => {
  if (!is_client || !activeProjects || !activeProjects.length) {
    return null;
  }

  return (<div className="profile-testimonials">
    <table className="table table-default drafts">
      <thead>
        <tr>
          <td><h2>Active Projects</h2></td>
          <td>Time Left</td>
          <td>Award</td>
          <td className="hide-for-small-only">Entries</td>
          <td className="hide-for-small-only">Feedback</td>
        </tr>
      </thead>
      <tbody>
        { activeProjects.map((project) => {
          const { total_awards_and_tips, entry_count, deadline } = project;
          const daysLeft = getTimeLeftLabel(deadline);

          return (<tr key={v4()}>
            <td className="project-name">
              <ProjectLink project={project} />
            </td>
            <td>{daysLeft}</td>
            <td><Money value={total_awards_and_tips} showDecimals={false} /></td>
            <td className="hide-for-small-only">{entry_count}</td>
            <td className="hide-for-small-only">
              <Feedback project={project}/>
            </td>
          </tr>);
        })}
      </tbody>
    </table>
  </div>);
};

ActiveProjects.propTypes = {
  is_client: PropTypes.bool,
  activeProjects: PropTypes.arrayOf(PropTypes.shape({
    total_awards_and_tips: PropTypes.number,
    title: PropTypes.string,
    entry_count: PropTypes.number,
  })),
};

export default ActiveProjects;



// WEBPACK FOOTER //
// ./profile/components/projects.jsx